// Bulk-quota badge in the nav: "Bulk 1/2 today". Only visible when a session exists —
// signed-out viewers can't bulk-submit so the number would be meaningless. Reads
// GET /v1/bulk/usage (useBulkUsage) which 401s off-session; the hook is gated behind
// a resolved useMe. Mirrors FleetReadout's "fleet" class for the mono/data treatment.
//   <BulkBadge />   renders nothing until signed-in state + first answer are known
import { useBulkUsage, useConfig, useMe } from "@/hooks";

export function BulkBadge() {
  const { data: config } = useConfig();
  const authOn = !!config?.auth.enabled;
  const me = useMe({ enabled: authOn });
  const signedIn = authOn && me.isSuccess && me.data?.authenticated === true;
  const usage = useBulkUsage({ enabled: signedIn });
  if (!signedIn) return null;
  if (!usage.data) return null;
  const { used, quota } = usage.data;
  const exhausted = used >= quota;
  return (
    <span
      className={exhausted ? "fleet is-stale" : "fleet"}
      title={exhausted ? "Daily bulk quota reached — resets in 24h" : `${quota - used} of ${quota} bulk submissions left today`}
    >
      <b>
        {used}/{quota}
      </b>
      <span className="max-[1100px]:hidden">bulk today</span>
      <span className="min-[1100px]:hidden">bulk</span>
    </span>
  );
}
